import { userFromFirestore } from '@parallel-fluidics/shared/models/users';
import {
  doc,
  getDoc,
  getFirestore,
} from 'firebase/firestore';

export default async function fetchUserById(userId) {
  if (!userId) {
    throw new Error('User ID is required to fetch user data');
  }
  const userDocRef = doc(getFirestore(), 'users', userId);
  const userDoc = await getDoc(userDocRef);
  if (userDoc.exists()) {
    return userFromFirestore(userDoc);
  }
  throw new Error('User not found');
}
